import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { DeleteRow } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import ModalDeleteWorkingCenterUser from './ModalDeleteWorkingCenterUser'
import { WorkingCenterEmployeeExtended } from '../WorkingCenterEmployees/type'
import ModalAddWorkingCenterUser from './ModalAddWorkingCenterUser'

interface WorkingCenterUsersProps extends ComponentWithPermissions {
    basicData: WorkingCenterModelType | null
}

const WorkingCenterUsers: React.FC<WorkingCenterUsersProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('users', 'Usuarios'),
        newText: t('addUser', 'Nuevo usuario'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableWorkingCenterUsers} CreateModalComponent={ModalAddWorkingCenterUser} DeleteModalComponent={ModalDeleteWorkingCenterUser} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ WorkingCenterId: basicData?.id }} />
    )
}
interface TableWorkingCenterUsersProps extends TableComponentBaseScreenInnerProps {
    className?: string
    name?: string
    hideLoadFiltersButton?: boolean
}

export const TableWorkingCenterUsers: React.FC<TableWorkingCenterUsersProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams, ...rest }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<WorkingCenterEmployeeExtended> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                return <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        },
    ]
    return (
        <TwinTable columns={columns} name='workingCenterUsers' getDataFrom='/api/app/workingCenter/workingCenterUser/getAllUsersInners' extraWhereParams={extraWhereParams} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} {...rest} />
    )
}
export default WorkingCenterUsers